module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('download'), _c('div', {
    staticClass: "layout p1 m1 border flex"
  }, [_c('div', {
    staticClass: "flex-auto pr1 mr1 border-right border-color"
  }, [_c('div', {
    staticClass: "flex items-start"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('swiper', {
    attrs: {
      "data": _vm.dataCarousel
    }
  }), _c('side-bottom-list', {
    attrs: {
      "data": _vm.dataSideBottom
    }
  })], 1), _c('div', {
    staticClass: "col-4 pl2"
  }, [_c('side-right-list', {
    staticClass: "mt0",
    attrs: {
      "data": _vm.dataSide
    }
  })], 1)]), _c('detail-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataDetail.length > 0),
      expression: "dataDetail.length > 0"
    }],
    staticClass: "border-top border-color",
    attrs: {
      "data": _vm.dataDetail
    }
  }), _c('classify-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataPrimary.length > 0),
      expression: "dataPrimary.length > 0"
    }],
    staticClass: "border-top border-color",
    attrs: {
      "data": _vm.dataPrimary,
      "keys": _vm.dataPrimaryKeys,
      "cids": _vm.cids
    }
  })], 1), _c('div', {
    staticStyle: {
      "width": "300px",
      "min-width": "300px"
    }
  }, [_c('admzone'), _c('sticky-list', {
    attrs: {
      "data": _vm.dataSticky
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3de7ee27","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 909
// module chunks = 1